import React from 'react';
import { MerchantHeadWrapper } from '../common.style';
import { MerchantSalesReportWrapper } from './MerchantSalesReport.style';
import GoBack from 'components/GoBack';
import Loader from 'components/Loader';
import InvoicesMerchantHead from '../../InvoicesMerchantHead';
import InformationSalesReport from '../../InvoicesMerchantInformation/InformationSalesReport';
import { useQuery } from 'react-query';
import { getSubscriptionPlanDetail } from 'services/merchantService';

const MerchantSalesReport = ({ onId }: { onId: number }) => {
  const { isLoading: loadingData, data: planDetail } = useQuery(
    ['planDetail', onId],
    ({ signal }) => getSubscriptionPlanDetail(onId, signal)
  );

  return (
    <MerchantSalesReportWrapper>
      <MerchantHeadWrapper>
        <GoBack />
        <InvoicesMerchantHead onData={planDetail} label="Abonnement Achil" />
      </MerchantHeadWrapper>
      {planDetail && <InformationSalesReport onData={planDetail} />}
      {loadingData ? <Loader /> : null}
    </MerchantSalesReportWrapper>
  );
};

export default MerchantSalesReport;
